import debugUtil from '../util/debug';
const Config = require('../config');

const Debug = debugUtil('svt-data');
const NAMESPACE = 'svt-data';
const SESSION_NUDGE_FREQUENCY = 30 * 1000; // todo: higher/lower value?
const instances = new Map();

class SvtDataPlugin {
    constructor(api, sdkClient) {
        this.api = api;
        this.hasStarted = false;
        this.hasCompleted = false;
        this.videoId = '';
        this.sdkClient = sdkClient;
        this.isPlaying = false;

        this.setupListeners();

        this.sessionNudgeInterval = setInterval(() => {
            if (this.isPlaying) {
                Debug.log("nudging session");
                this.sdkClient.keepSessionAlive();
            }
        }, SESSION_NUDGE_FREQUENCY);
    }

    setupListeners() {
        this.api.on(`${NAMESPACE}.metadata`, ({ detail }) => {
            this.hasStarted = false;
            this.hasCompleted = false;
            this.videoId = detail.programVersionId;
            Debug.log('video id', this.videoId);
        });

        this.api.on(`${NAMESPACE}.playing`, () => {
            if (!this.hasStarted) {
                this.sdkClient.trackVideoStart(this.videoId);
                Debug.log('Reporting start');
            }
            this.hasStarted = true;
            this.isPlaying = true;
        });

        this.api.on(`${NAMESPACE}.pause`, () => {
            this.isPlaying = false;
            Debug.log('Video paused');
        });

        this.api.on(`${NAMESPACE}.timeupdate`, () => {
            if (this.hasCompleted) {
                return;
            }
            const currentTime = this.api.getCurrentTime();
            const duration = this.api.getDuration();

            if (currentTime / duration >= 0.9) {
                this.sdkClient.trackVideoCompletion(this.videoId);
                Debug.log('Reporting completion');
                this.hasCompleted = true;
            }
        });

        this.api.on(`${NAMESPACE}.ended`, () => {
            this.hasStarted = false;
            this.hasCompleted = false;
            this.isPlaying = false;
        });
    }

    destroy() {
        this.api.off(`${NAMESPACE}.metadata`);
        this.api.off(`${NAMESPACE}.playing`);
        this.api.off(`${NAMESPACE}.timeupdate`);
        this.api.off(`${NAMESPACE}.ended`);
        this.api.off(`${NAMESPACE}.pause`);

        clearInterval(this.sessionNudgeInterval);
    }
}

export function create(api) {
    if (instances.has(api)) {
        Debug.warn(
            `Svt-data plugin was already created for this api instance and has
            not been destroyed. The previous instance may leak memory and listeners.`
        );
    }

    const sdkClient = Config.svtDataSdkClient;
    if (sdkClient) {
        Debug.log('Creating Svt-Data');
        instances.set(api, new SvtDataPlugin(api, sdkClient));
    }
}

export function destroy(api) {
    const instance = instances.get(api);
    if (instance) {
        instance.destroy();
        instances.delete(api);
    }
}



// WEBPACK FOOTER //
// ./src/js/plugins/svt-data.js